/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsSupportToken
 */
export interface MelcoModelsSupportToken {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsSupportToken
     */
    token?: string | null;
}

export function MelcoModelsSupportTokenFromJSON(json: any): MelcoModelsSupportToken {
    return MelcoModelsSupportTokenFromJSONTyped(json, false);
}

export function MelcoModelsSupportTokenFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsSupportToken {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': !exists(json, 'token') ? undefined : json['token'],
    };
}

export function MelcoModelsSupportTokenToJSON(value?: MelcoModelsSupportToken | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
    };
}


